import "./AddCompany.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AddCompanyComponentController from "./AddCompanyComponentController";

export default class AddCompanyComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddCompanyComponentController;
        this.templateUrl = "/App/Components/Companies/Add/AddCompany.html";
    }
}

module("mmManagePortal").component("irAddCompany", new AddCompanyComponent());
